import { createContext, useEffect } from "react";

export const ReloadContext = createContext();

export const ReloadProvider = ({ children }) => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      sessionStorage.clear();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  return <ReloadContext.Provider value={{}}>{children}</ReloadContext.Provider>;
};
